module.exports = __webpack_public_path__ + "img/floor_EG.edb2a0cf.svg";